import React, { useState } from "react";
import { Button } from "./ui/button";
import { Phone, Mail, MessageCircle, Plus, X } from "lucide-react";
import { contactInfo } from "../data/mockData";

const FloatingActionButtons = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePhoneCall = () => {
    window.location.href = `tel:${contactInfo.phone.replace(/\s/g, '')}`;
  };

  const handleWhatsApp = () => {
    // Korrekte Schweizer Telefonnummer-Formatierung für WhatsApp
    const phoneNumber = "41766113131"; // +41 766 11 31 31 ohne Leerzeichen und Plus
    const message = encodeURIComponent("Hallo! Ich möchte gerne ein Taxi buchen. 🚕");
    
    // Verwende wa.me für bessere Kompatibilität
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    // Öffne WhatsApp (funktioniert auf allen Geräten)
    window.open(whatsappUrl, '_blank');
  };

  const handleEmail = () => {
    const subject = encodeURIComponent("Taxi-Buchung Anfrage");
    const body = encodeURIComponent("Hallo,\n\nIch möchte gerne ein Taxi buchen.\n\nVielen Dank!");
    window.location.href = `mailto:${contactInfo.email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="fixed bottom-6 left-6 z-50">
      {/* Action Buttons */}
      <div className={`flex flex-col space-y-3 mb-4 transition-all duration-300 ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}`}>
        {/* WhatsApp Button */}
        <Button
          onClick={handleWhatsApp}
          className="text-white w-16 h-16 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group relative"
          style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#128C7E'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#25D366'}
          size="lg"
        >
          <svg
            className="w-7 h-7"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
          </svg>
          <div className="absolute left-16 top-1/2 transform -translate-y-1/2 bg-black text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            WhatsApp
          </div>
        </Button>

        {/* Phone Button */}
        <Button
          onClick={handlePhoneCall}
          className="bg-blue-500 hover:bg-blue-600 text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group relative"
          size="lg"
        >
          <Phone className="w-6 h-6" />
          <div className="absolute left-16 top-1/2 transform -translate-y-1/2 bg-black text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            Anrufen
          </div>
        </Button>

        {/* Email Button */}
        <Button
          onClick={handleEmail}
          className="bg-red-500 hover:bg-red-600 text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group relative"
          size="lg"
        >
          <Mail className="w-6 h-6" />
          <div className="absolute left-16 top-1/2 transform -translate-y-1/2 bg-black text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            E-Mail
          </div>
        </Button>
      </div>

      {/* Main Toggle Button */}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-yellow-600 hover:bg-yellow-700 text-white w-16 h-16 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 ${isOpen ? 'rotate-45' : 'rotate-0'}`}
        size="lg"
      >
        {isOpen ? <X className="w-8 h-8" /> : <Plus className="w-8 h-8" />}
      </Button>

      {/* Quick Phone Button (Always Visible) - Next to Plus Button */}
      <div className="absolute bottom-6 left-20">
        <Button
          onClick={handlePhoneCall}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
        >
          <Phone className="w-5 h-5 mr-2" />
          <span className="text-sm font-semibold">{contactInfo.phone}</span>
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Jetzt anrufen!
          </div>
        </Button>
      </div>


    </div>
  );
};

export default FloatingActionButtons;